import requestAction from '../../utils/requestAction'

export const fetchJabberUsers = (params: string = "") =>
  requestAction('SCHOOL_JABBER_USER_LIST', params)(`school-jabber-users`, 'GET')
